<template>
  <tr>
    <!-- title -->
    <td class="text-left ml-5">
      <router-link class="color-default" :to="'/faqs/' + FAQ.slug">{{ FAQ.title }}</router-link>
    </td>
    <td>
      {{ FAQ.FAQCategory.title }}
    </td>
    <td v-if="FAQ.published == 1">
      <span class="text-success font-weight-bold">Yes</span>
    </td>
    <td v-else>
      <span class="text-danger font-weight-bold">No</span>
    </td>
    <!-- controls [Update, Delete] -->
    <td>
      <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
        <span class="fas fa-ellipsis-v"></span>
      </a>
      <ul class="dropdown-menu">
        <router-link class="dropdown-item" :to="'/faqs/update-faq/' + this.FAQ.slug">Update</router-link>
        <template>
          <a class="dropdown-item" v-if="FAQ.published == 0" @click="publishing('publish')">Publish</a>
          <a class="dropdown-item" v-else @click="publishing('unpublish')">Unpublish</a>
        </template>
        <a class="dropdown-item text-danger" @click="deleteFAQ">Delete</a>
      </ul>
    </td>

    <!--<div v-if="typeof FAQ.author !== 'undefined'" class="btn-group btn-group-sm">-->
    <!--<router-link-->
    <!--v-if="$gate.allow('update', 'FAQ', FAQ)" -->
    <!--:to="'/faqs/update-faq/' + this.FAQ.slug"-->
    <!--class="btn btn-success" -->
    <!--&gt;Edit</router-link>-->
    <!--<template v-if="$gate.allow('publish', 'FAQ', FAQ)">-->
    <!--<button-->
    <!--v-if="FAQ.published == 0"-->
    <!--@click="publishing('publish')"-->
    <!--type="button"-->
    <!--class="btn btn-primary btn-sm"-->
    <!--&gt;Publish</button>-->
    <!--<button-->
    <!--v-else-->
    <!--@click="publishing('unpublish')"-->
    <!--type="button"-->
    <!--class="btn btn-warning btn-sm"-->
    <!--&gt;Unpublish</button>-->
    <!--</template>-->
    <!--<button -->
    <!--v-if="$gate.allow('delete', 'FAQ', FAQ)"-->
    <!--@click="deleteFAQ"-->
    <!--type="button"-->
    <!--class="btn btn-danger"-->
    <!--&gt;Delete</button>-->
    <!--</div>-->
    <!--</td>-->
  </tr>
</template>

<script>
  export default {
    name: "FAQRow",
    props: ["FAQ"],
    computed: {
      author: function () {
        if (typeof this.FAQ.author === "undefined") {
          return "unknown";
        }
        return this.FAQ.author.name;
      },
    },
    methods: {
      publishing(action) {
        this.$store
          .dispatch("faqs/publishing", {
            FAQ: this.FAQ,
            action: action,
          })
          .then((response) => {
            this.$store.dispatch(
              "message/update",
              {
                title: this.FAQ.title,
                body: response.data.message,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
          });
      },
      deleteFAQ() {
        this.$store.dispatch("message/update", {
          title: this.FAQ.title,
          body: "Are you sure you want to delete this FAQ?",
          class: "danger",
          confirm: true,
        });

        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.delete(this.FAQ);
          this.$store.dispatch("message/close");
        });
      },
      delete(FAQ) {
        this.$store.dispatch("faqs/deleteFAQ", FAQ)
          .then((message) => {
            // send successful message
            this.$toast.success(message);
          })
          .catch((error) => {
            // send error message
            this.$toast.success(error.response.data.message);
          });
      },
    },
  };
</script>
<style scoped>
  table tr td:nth-child(1) {
    width: 35% !important;
    padding-left: 40px;
  }

  table tr td:nth-child(2) {
    width: 35% !important;
  }

  table tr td:nth-child(3) {
    width: 20% !important;
  }

  table tr td:nth-child(4) {
    width: 10% !important;
  }
</style>